export const DEFAULT_ORDER_SUMMARY_TEMPLATE = `ຂອບໃຈທີ່ສັ່ງຊື້ {{shop_display_name}} 🌻
ອໍເດີ້ {{order_number}}

{{customer_line}}
{{phone_line}}
ຮັບ/ສົ່ງ: {{delivery_summary}}
{{address_block}}

{{lines}}
─────────────────
ຍອດລວມສິນຄ້າ: {{subtotal}}
{{discount_line}}
{{shipping_line}}
ລວມທັງໝົດ: {{total}}
ຊຳລະ: {{payment_type}}

{{bank_block}}`;

export const DEFAULT_SHOP_DISPLAY_NAME = "Sunlower Supplies";
